import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { verifyAiPackageById } from "../../ApiController/ApiService";
import { XCircle, Loader2, Cpu } from "lucide-react";

const FailedAiPackage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isVerifying, setIsVerifying] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!id) {
      setIsVerifying(false);
      setError("AI Package Token is missing");
      return;
    }

    const verifyPackage = async () => {
      try {
        const result = await verifyAiPackageById(id, "Failed");

        if (!result?.success) {
          setError(result?.message || "AI Package activation failed");
        } else {
          navigate("/dashboard");
        }
      } catch {
        setError("Something went wrong while activating AI package");
      } finally {
        setIsVerifying(false);
      }
    };

    verifyPackage();
  }, [id, navigate]);

  return (
    <div className="min-h-screen bg-[#050510] flex items-center justify-center p-4">
      {/* Red Glow */}
      <div className="absolute w-[320px] h-[320px] bg-red-600 rounded-full blur-[140px] opacity-20" />

      <div className="relative bg-[#0F0D2E]/80 border border-white/10 p-10 rounded-[2rem] w-full max-w-lg text-center shadow-2xl backdrop-blur-3xl">
        {/* Header */}
        <h2 className="text-[34px] font-bold text-white leading-tight">
          AI Package <br />
          <span className="text-red-500 drop-shadow-[0_0_18px_rgba(239,68,68,0.5)]">
            Activation Failed
          </span>
        </h2>

        <p className="text-gray-400 mt-4">
          The AI system couldn’t complete activation. Please retry.
        </p>

        {/* Icon */}
        <div className="flex justify-center my-10 relative">
          <div className="absolute inset-0 bg-red-500 rounded-full blur-3xl opacity-25 animate-pulse" />
          <XCircle
            size={140}
            className="relative z-10 text-red-500"
            strokeWidth={1.4}
          />
        </div>

        {/* Status */}
        {isVerifying && (
          <div className="flex justify-center items-center gap-3">
            <Loader2 className="animate-spin text-red-400" size={18} />
            <p className="text-red-300 text-sm tracking-widest">
              VERIFYING AI MODULES...
            </p>
          </div>
        )}

        {!isVerifying && error && (
          <div className="bg-red-500/10 border border-red-500/20 p-4 rounded-xl mt-4">
            <p className="text-red-400 text-sm">{error}</p>
          </div>
        )}

        {/* Actions */}
        {!isVerifying && (
          <div className="flex gap-4 justify-center mt-8">
            <button
              onClick={() => window.location.reload()}
              className="flex items-center gap-2 px-6 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white text-sm transition"
            >
              <Cpu size={16} />
              Retry Activation
            </button>

            <button
              onClick={() => navigate("/dashboard")}
              className="px-6 py-2 rounded-lg border border-white/20 text-white text-sm hover:bg-white/10 transition"
            >
              Go to Dashboard
            </button>
          </div>
        )}

        <p className="text-xs text-gray-500 uppercase tracking-[0.25em] mt-6">
          AI SYSTEM STATUS : FAILED
        </p>
      </div>
    </div>
  );
};

export default FailedAiPackage;
